export default __webpack_public_path__ + "static/rounded-left-10ef86a311667dd8c8070d28810bc94f.png";